import SEO from "../components/common/SEO"
import PageBanner from "../components/layout/PageBanner"

export default function TermsConditions() {
  return (
    <>
      <SEO
        title="Conditions générales d'utilisation"
        description="Conditions générales d'utilisation du site."
        keywords="conditions générales, CGU, utilisation du site"
        url="https://www.khenissitextiles.com/conditions-generales"
      />

      <PageBanner
        title="Conditions générales d'utilisation"
        subtitle="Règles et conditions applicables à l'utilisation du site."
      />

      <section className="py-16 lg:py-24">
        <div className="container mx-auto px-4 lg:px-8 max-w-4xl">

          <div className="space-y-8 text-gray-700 leading-relaxed">

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">
                1. Objet
              </h2>

              <p>
                Les présentes conditions générales d'utilisation définissent
                les modalités d'accès et d'utilisation du site ainsi que les
                droits et obligations des utilisateurs.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">
                2. Accès au site
              </h2>

              <p>
                Le site est accessible gratuitement à tout utilisateur
                disposant d'un accès à Internet. Tous les frais liés à
                l'accès au service demeurent à la charge de l'utilisateur.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">
                3. Informations fournies
              </h2>

              <p>
                Les informations présentes sur ce site sont fournies à titre
                indicatif. Malgré le soin apporté à leur mise à jour, elles
                peuvent contenir des erreurs ou omissions.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">
                4. Produits et services
              </h2>

              <p>
                Les produits présentés sur le site ont une vocation
                informative. Leur disponibilité, leurs caractéristiques ou
                leurs références peuvent être modifiées sans préavis.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">
                5. Propriété intellectuelle
              </h2>

              <p>
                L'ensemble du contenu du site, incluant notamment les textes,
                images, logos, graphismes et éléments visuels, est protégé
                par les lois relatives à la propriété intellectuelle.
              </p>

              <p className="mt-3">
                Toute reproduction, diffusion ou utilisation sans
                autorisation préalable est interdite.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">
                6. Responsabilité
              </h2>

              <p>
                L'éditeur du site ne pourra être tenu responsable des
                dommages directs ou indirects résultant de l'utilisation
                du site ou de l'impossibilité d'y accéder.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">
                7. Liens externes
              </h2>

              <p>
                Le site peut contenir des liens vers des services externes
                tels que WhatsApp ou Google Maps. L'éditeur ne peut être tenu
                responsable du contenu ou du fonctionnement de ces services
                tiers.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">
                8. Protection des données
              </h2>

              <p>
                Les données personnelles éventuellement collectées sont
                traitées conformément à notre Politique de confidentialité.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">
                9. Modification des conditions
              </h2>

              <p>
                Nous nous réservons le droit de modifier les présentes
                conditions générales à tout moment afin de les adapter aux
                évolutions du site ou aux exigences légales.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">
                10. Droit applicable
              </h2>

              <p>
                Les présentes conditions sont régies par la législation
                applicable en Tunisie.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">
                11. Contact
              </h2>

              <p>
                Pour toute question concernant ces conditions générales
                d'utilisation, veuillez nous contacter via la page Contact.
              </p>
            </div>

            <p className="text-sm text-gray-500 pt-6 border-t">
              Dernière mise à jour : Juin 2026
            </p>

          </div>

        </div>
      </section>
    </>
  )
}